


export const SEO_START = 'SEO_START';
export const SEO_END = 'SEO_END';
export const SEO_ERROR = 'SEO_ERROR';
export const SEO_SUCCESS = 'SEO_SUCCESS';
export const SEO_FAIL = 'SEO_FAIL';
export const IsDataSubmitedSuccessfully = 'IsDataSubmitedSuccessfully'